// extracted by mini-css-extract-plugin
export default {"container":"styles_container__WBF4+","options":"styles_options__XiDhY","option":"styles_option__ZIjZx","option_icon":"styles_option_icon__4P7ga","heading":"styles_heading__6r8KK"};